import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse } from '../models/api-response.model';
import { ClientRegistrationRecord } from './registration-form.service';

export interface ClientRegistrationReviewPayload {
  action: 'APPROVE' | 'REJECT';
  remarks?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ClientRegistrationManagementService {
  private readonly http = inject(HttpClient);

  list(): Observable<ApiResponse<ClientRegistrationRecord[]>> {
    return this.http.get<ApiResponse<ClientRegistrationRecord[]>>(API_ENDPOINTS.clientRegistrations.list);
  }

  get(registrationId: number): Observable<ApiResponse<ClientRegistrationRecord>> {
    return this.http.get<ApiResponse<ClientRegistrationRecord>>(`${API_ENDPOINTS.clientRegistrations.list}/${registrationId}`);
  }

  review(registrationId: number, payload: ClientRegistrationReviewPayload): Observable<ApiResponse<ClientRegistrationRecord>> {
    return this.http.post<ApiResponse<ClientRegistrationRecord>>(`${API_ENDPOINTS.clientRegistrations.list}/${registrationId}/review`, payload);
  }
}
